define("preview-grid/errors/index", ["exports", "preview-grid/errors/credentials", "preview-grid/errors/fetch", "preview-grid/errors/media-library"], function (_exports, _credentials, _fetch, _mediaLibrary) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "CredentialsMissingPermissionsError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsMissingPermissionsError;
    }
  });
  Object.defineProperty(_exports, "CredentialsNotFoundError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsNotFoundError;
    }
  });
  Object.defineProperty(_exports, "FetchError", {
    enumerable: true,
    get: function () {
      return _fetch.FetchError;
    }
  });
  Object.defineProperty(_exports, "ImageSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.ImageSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaUploadError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaUploadError;
    }
  });
  Object.defineProperty(_exports, "NetworkError", {
    enumerable: true,
    get: function () {
      return _fetch.NetworkError;
    }
  });
  Object.defineProperty(_exports, "RequestError", {
    enumerable: true,
    get: function () {
      return _fetch.RequestError;
    }
  });
  Object.defineProperty(_exports, "ServerError", {
    enumerable: true,
    get: function () {
      return _fetch.ServerError;
    }
  });
  Object.defineProperty(_exports, "UpgradeMediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.UpgradeMediaSizeError;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"preview-grid/errors/credentials",0,"preview-grid/errors/fetch",0,"preview-grid/errors/media-library"eaimeta@70e063a35619d71f
});